import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { createStyles, Badge } from '@mantine/core';

// Hooks
import { useStaticKey } from '../../../hooks/useStaticKey';

// Manifest
import { manifest } from '../../../../../manifests/questionManifest';

const useStyles = createStyles((theme) => ({
    badgeRoot: {
        background: '#168f5c'
    }
}));
interface IAnswerValuePillProps {
    answers: Record<string, any>;
    staticKey: string;
}

export const AnswerValuePill: React.FC<IAnswerValuePillProps> = ({ answers, staticKey }) => {
    const { classes } = useStyles();
    const { getNameByStaticKey } = useStaticKey();
    const { t } = useTranslation('questions');
    const formattedValue = React.useMemo(() => {
        const val = answers?.[getNameByStaticKey(staticKey)];
        const label =
            typeof manifest[staticKey]?.componentProps?.labelKey === 'string'
                ? t(manifest[staticKey]?.componentProps?.labelKey as string)
                : '';

        return `${label}: ${manifest[staticKey]?.displayValueAs ? manifest[staticKey].displayValueAs?.(val) : val}`;
    }, [staticKey, answers, getNameByStaticKey, t]);
    return (
        <Badge
            variant="filled"
            classNames={{
                root: classes.badgeRoot
            }}
        >
            {formattedValue}
        </Badge>
    );
};
